module.exports = __webpack_public_path__ + "static/media/syncWhatsapp_step2_hk.97203e6b.jpg";